@if (store.asArray(); as stories) {
  @if (stories.length > 0) {
    <p-table
      #storyTable
      [globalFilterFields]="['title']"
      [loading]="loading"
      [value]="stories">
      <ng-template pTemplate="caption">
        <app-table-list-caption
          [searchWord]="searchWord"
          (clearTable)="clear(storyTable)"
          (search)="
            storyTable.filterGlobal($event, 'contains')
          "></app-table-list-caption>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Themenbereich</th>
          <th>Ansichten</th>
          <th>Aktionen</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-story>
        <tr>
          <td>
            <span class="flex gap-2 align-items-center">
              <i class="fas fa-file-lines"></i>
              {{ story.title }}
            </span>
          </td>
          <td>
            @if (story.category) {
              {{ categoryStore.getById(story.category)?.title }}
            } @else {
              <i class="text-color-secondary">nicht zugeordnet</i>
            }
          </td>
          <td><p-badge [value]="story.bookmarks.length"></p-badge></td>
          <td>
            <app-table-list-actions
              [item]="story"
              (confirm)="confirm($event, story, story.title)">
            </app-table-list-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-alert header="Keine Berichte gefunden" [canToggle]="false">
      Sie wollen Ihre Ansichten als Bericht zur Verfügung stellen? Nutzen Sie
      das
      <a
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['berichte', { outlets: { bearbeiten: 'neu' } }],
            },
          },
        ]"
        >Formular</a
      >.
    </app-alert>
  }
}
<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-9'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
